/*
 * @Author: your name
 * @Date: 2022-03-05 17:08:20
 * @LastEditTime: 2024-05-06 17:24:48
 * @LastEditors: bobo 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\BsyUserThumbList\index.jsx
 */
import React, { Component } from "react";

import "./index.css";
import { BsyUtils } from "../../utils/Utils";
import BsyMsgBubble from "../BsyMsgBubble";
import BsyDeptUserPane from "../BsyDeptUserPane";

export default class BsyDeptThumbList extends Component {
  static defaultProps = {
    list: [],
    is_dock_form: false,
  };
  constructor(props) {
    super(props);
    this.state = {
      list: props.list,
      appId: props.appId,
      is_dock_form: props.is_dock_form,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    this.setState({
      ...nextProps,
    });
  }

  loadData = (id, cb) => {
    const { appId, is_dock_form } = this.state;
    if (is_dock_form) {
      return;
    }
    React.axios("/data/department/hover_detail", {
      dept_id: id,
      appId: appId || window.FX.STATIC.APPID,
    })
      .then((res) => {
        BsyUtils.showAjaxTip(res.data, () => {
          cb && cb(res.data);
        });
      })
      .catch((res) => {
        console.error(res);
      });
  };

  showUserInfo = (data, t) => {
    if (window.FX.STATIC.QTOKEN) {
      return;
    }

    this.loadData(data.id || data._id, (info) => {
      BsyMsgBubble({
        anchor: t.target,
        contentHTML: (ref) => {
          return (
            <BsyDeptUserPane
              type={"dept"}
              status={info.status === -99 ? "deleted" : ""}
              info={{ ...info }}
            />
          );
        },
        text4Cancel: null,
        text4Ok: null,
        theme: this.props.theme,
        minWidth: "auto",
        width: 300,
        contentPadding: 0,
        edge: 200,
        hAdjust: 72,
        dockPosition: "left",
        onClose: function () {
          return !1;
        },
      });
    });
  };

  render() {
    const { list } = this.state;
    return (
      <div className="bsy-dept-thumb-list">
        {!list
          ? ""
          : list.map((data, index) => {
              // let name = data.nickname || data.name || data.id;
              if (BsyUtils.isString(data)) {
                data = window.deptSelectMap[data] || data;
              }
              let id = data._id || data.id;
              let name = BsyUtils._toDeptUser(data);
              return index === 0 ? (
                <>
                  <span
                    key={"bsy-dept-thumb-list-" + id}
                    className={
                      "dept-item" + (data.status === -99 ? " error" : "")
                    }
                    onClick={(e) => {
                      e.stopPropagation();
                      this.showUserInfo(data, e);
                    }}
                  >
                    {name}
                  </span>
                </>
              ) : (
                <>
                  <span key={"bsy-dept-thumb-listd-" + +id}>,</span>
                  <span
                    key={"bsy-dept-thumb-list-" + (id + "e")}
                    className={
                      "dept-item" + (data.status === -99 ? " error" : "")
                    }
                    onClick={(e) => {
                      e.stopPropagation();
                      this.showUserInfo(data, e);
                    }}
                  >
                    {name}
                  </span>
                </>
              );
            })}
      </div>
    );
  }
}
